// Helper function to get user's timezone
export const getUserTimezone = () => {
  try {
    // Get timezone using Intl API (e.g., "America/New_York", "Europe/London")
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    // Fallback to offset-based timezone (e.g., "GMT+5:30")
    const offset = -new Date().getTimezoneOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? "+" : "-";
    return `GMT${sign}${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}`;
  }
};
